
import { mapMutations } from 'vuex'
import api from '~/api/'
export default {
    name: 'CompanySearch',
    data() {
        return { companyList: [], selected: {} }
    },
    watch: {
        selected() {
            if (this.selected.code === '000') {
                this.selected.code = ''
            }
            this.SET_COMPANY(this.selected)
        },
    },
    created() {
        this.getCompanyList()
    },
    methods: {
        ...mapMutations('search', ['SET_COMPANY']),
        async getCompanyList() {
            const res = await api.getStockCompanyList({
                newsType: 'STOCK_NEW_RECOMMEND',
            })
            this.companyList = res.data
        },
    },
}
